/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Scope_BothInputs */

const cs_ebr_scope_both = /** @type {(inputs: Ebr_Scope_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléři i nabídky`)
};

const en_ebr_scope_both = /** @type {(inputs: Ebr_Scope_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers and offers`)
};

/**
* | output |
* | --- |
* | "Brokers and offers" |
*
* @param {Ebr_Scope_BothInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_scope_both = /** @type {((inputs?: Ebr_Scope_BothInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Scope_BothInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_scope_both(inputs)
	return cs_ebr_scope_both(inputs)
});